export default __webpack_public_path__ + "static/embossing-a387cb30cf62b4208be17c02f41ba244.png";